// Production'da yalnızca yedek dil (tr) ilk pakette gelir; diğer diller gerektiğinde ayrı dosya olarak indirilir.
// Geliştirme modunda main.js tüm dilleri kaynaklardan doğrudan yükler, burada yapılacak bir şey yoktur.
const loadedLocales = new Set(["tr"]);
let i18nInstance = null;

export function registerI18n(i18n) {
    i18nInstance = i18n;
}

export async function loadLocale(lang) {
    if (process.env.NODE_ENV !== "development") {
        if (!lang || !i18nInstance || loadedLocales.has(lang)) return;

        try {
            const messages = await import(/* webpackChunkName: "locale-[request]" */ `./generated/${lang}.json`);

            i18nInstance.global.setLocaleMessage(lang, messages.default);
            loadedLocales.add(lang);
        } catch (error) {
            // Dil dosyası inemezse arayüz yedek dil (tr) ile çalışmaya devam eder; dil değişimi sayfayı kırmamalı.
        }
    }
}
